import { ListEnum as e } from "../list-enum.mjs";
import { Dotpoints01BulletsIcon as t, NumberedListBulletsIcon as n } from "@systemeio/icons";
//#region src/extensions/list-extension/utils/list.ts
var r = ({ listType: t, editor: n }) => {
	if (n) switch (t) {
		case e.BulletList:
			n.chain().focus().toggleBulletList().run();
			break;
		case e.OrderedList: n.chain().focus().toggleOrderedList().run();
	}
}, i = ({ listType: r }) => {
	switch (r) {
		case e.BulletList: return t;
		case e.OrderedList: return n;
	}
}, a = (e) => {
	switch (e) {
		case 0: return "disc";
		case 1: return "circle";
		default: return "square";
	}
}, o = (e) => {
	switch (e) {
		case 0: return "decimal";
		case 1: return "lower-latin";
		case 2: return "lower-roman";
		case 3: return "upper-latin";
		default: return "upper-roman";
	}
};
//#endregion
export { a as getBulletListStyleType, i as getListIcon, o as getOrderedListStyleType, r as setList };
